import { YesNoIndicators } from '../../../../global/models/api-model';
import { AEDependent, AEOffering, AETierCalculations, Enrollment, FormInfo, FormRecord } from '../../../annual-enrollment/models/annual-enrollment-models';

export enum MidYearPlanType {
	None = 'None',
	Medical = 'M',
	Dental = 'D',
	Group = 'G',
	SuppLife = 'S',
	SuppSpouse = 'P',
	ShortTermDisable = 'W',
	LongTermDisable = 'L',
	Unemployment = 'U',
}

export interface MidYearConfirmationFormValue {
	date_of_qualifying_event: string,
	[MidYearPlanType.Medical]: string[];
	[MidYearPlanType.Dental]: string[];
	memo?: string;
	specialRequests?: string;
	decline_reason?: string;
	decline_reason_other?: string;
	extenuating_circumstances?: string;
}

export interface GlobalData {
	date_of_qualifying_event: string,
	memo: string,
	special_requests: string,
	user_acknowledgement: YesNoIndicators,
	decline_reason : string,
	decline_reason_other : string,
	extenuating_circumstances: string,
}

export interface MidYearEnrollment {
	api_response?: { message: string, status: string };
	enrollments_base: {
		D: Enrollment[];
		G: Enrollment[];
		L: Enrollment[];
		M: Enrollment[];
		P: Enrollment[];
		S: Enrollment[];
		W: Enrollment[];
		U: Enrollment[];
	};
	enrollments_edited?: {
		D: Enrollment[];
		G: Enrollment[];
		L: Enrollment[];
		M: Enrollment[];
		P: Enrollment[];
		S: Enrollment[];
		W: Enrollment[];
		U: Enrollment[];
	};
	dep_enrollments_base: {
		[_guid: string]: {
			D: YesNoIndicators,
			M: YesNoIndicators,
		}
	},
	dep_enrollments_edited?: {
		[_guid: string]: {
			D: YesNoIndicators,
			M: YesNoIndicators,
		}
	},
	eligible_dependents: AEDependent[];
	offerings: {
		D: AEOffering;
		G: AEOffering;
		L: AEOffering;
		M: AEOffering;
		P: AEOffering;
		S: AEOffering;
		W: AEOffering;
		U: AEOffering;
	},
	processing_messages?: {
		confirm: string[],
		errors: string[],
		flags: string[],
		mc_holds: string[],
		notes: string[],
		rq_holds: string[],
		to_dos: string[],
		tx_holds: string[],
		warnings: string[],
	},

	global_base: GlobalData,
	global_edited: GlobalData,

	form_info?: FormInfo,
	form_record?: FormRecord,

}

export interface MidYearEnrollmentFormValue {
	date_of_qualifying_event: string;
	[MidYearPlanType.Medical]: string[];
	[MidYearPlanType.Dental]: string[];

	kaiserArbitrationAgreement?: boolean;

	medicalPlanBillingAccount: string;
	medicalPlan: string;
	medicalPlanEffectiveDate: string;
	medicalPlanTerminateDate: string;

	dentalPlanBillingAccount: string;
	dentalPlan: string;
	dentalPlanEffectiveDate: string;
	dentalPlanTerminateDate: string;

	groupLifePlanBillingAccount: string;
	groupLifePlan: string;
	groupLifePlanVolume: string;
	groupLifePlanEffectiveDate: string;
	groupLifePlanTerminateDate: string;


	//supplementalLifePlanBillingAccount: string;
	//supplementalLifePlan: string;
	//supplementalLifePlanVolume: string;
	//supplementalLifePlanEffectiveDate: string;
	//supplementalLifePlanTerminateDate: string;

	//supplementalSpousePlanBillingAccount: string;
	//supplementalSpousePlan: string;
	//supplementalSpousePlanVolume: string;
	//supplementalSpousePlanEffectiveDate: string;
	//supplementalSpousePlanTerminateDate: string;

	longTermDisabilityPlanBillingAccount: string;
	longTermDisabilityPlan: string;
	longTermDisabilityPlanVolume: string;
	longTermDisabilityPlanEffectiveDate: string;
	longTermDisabilityPlanTerminateDate: string;

	shortTermDisabilityPlanBillingAccount: string;
	shortTermDisabilityPlan: string;
	shortTermDisabilityPlanVolume: string;
	shortTermDisabilityPlanEffectiveDate: string;
	shortTermDisabilityPlanTerminateDate: string;

	unemploymentInsurancePlanBillingAccount: string;
	unemploymentInsurancePlan: string;
	unemploymentInsurancePlanVolume: string;
	unemploymentInsurancePlanEffectiveDate: string;
	unemploymentInsurancePlanTerminateDate: string;

	memo?: string;
	specialRequests?: string;
	cafeteriaAcknowledgement?: boolean;
	extenuatingCircumstances?: string;
}

export interface MidyearEnrollmentState {
	currentMidYearEnrollment: MidYearEnrollment,
	midYearLoaded: boolean,
	tierCalculations: {
		[MidYearPlanType.Medical]: AETierCalculations;
		[MidYearPlanType.Dental]: AETierCalculations;
	}
}

export enum MidYearAction {
	SET_MID_YEAR_ENROLLMENT = 'SET_MID_YEAR_ENROLLMENT',
	CLEAR_MID_YEAR_STATE = 'CLEAR_MID_YEAR_STATE',
	SET_TIER_CALCULATION = 'SET_TIER_CALCULATION',
}

export enum MidYearQualifyingDateBanner {
	NONE = 'none',
	WARNING = 'warning',
	INFO = 'information',
}

export enum MidYearQualifyingDateExtenuatingCircumstances {
	MINIMUM = 60,
	MAXIMUM = 180,
	INITIAL = 0,
}